import { Container, SimpleGrid, Divider, VStack } from '@chakra-ui/react';
import Breadcrumbs from '../../common/Breadcrumbs';
import FeatureFlagGuard from '../../common/FeatureFlagGuard';
import FormAccountDetails from '../../components/client/account/FormAccountDetails';
import FormChangeEmailAddress from '../../components/client/account/FormChangeEmailAddress';
import FormChangePassword from '../../components/client/account/FormChangePassword';
import MfaSettings from '../../components/client/account/MfaSettings';
import { useContext } from 'react';
// import NightModeSwitcher from '../../components/client/account/NightModeSwitcher';
import { MeContext } from '../../context/MeContext';
import TeamInvitations from '../../components/client/account/TeamInvitations';
import useOrganizationStatus from '../../hooks/useOrganisationStatus';
import PageHeadingWithTrialProgress from '../../components/client/dashboard/PageHeadingWithTrialProgress';

function AccountSettingsPage() {
  const meCtx = useContext(MeContext);
  const { shouldRender, components } = useOrganizationStatus();

  const user = meCtx?.state?.data;

  const breadcrumbLinks = [
    {
      linkName: 'Home',
      linkUrl: '/',
    },
    {
      linkName: 'account settings',
      linkUrl: null,
    },
  ];

  return (
    <Container pb={6}>
      <Breadcrumbs breadcrumbLinks={breadcrumbLinks} />
      <PageHeadingWithTrialProgress title="Account settings" />
      <Divider borderColor="primaryBackground" mb={6} />

      {components[0]}

      <SimpleGrid
        w="full"
        columns={{ base: 1, xl: 2 }}
        columnGap={6}
        rowGap={6}
      >
        <VStack spacing={6}>
          <FormAccountDetails user={user} />
          {shouldRender && <TeamInvitations />}
          {/* <NightModeSwitcher /> */}
        </VStack>
        <VStack spacing={6}>
          <FormChangeEmailAddress user={user} />
          <FormChangePassword />
          <FeatureFlagGuard
            flagKey="mfa_enabled"
            redirectOnError={false}
            redirectOnDisabled={false}
          >
            <MfaSettings />
          </FeatureFlagGuard>
        </VStack>
      </SimpleGrid>
    </Container>
  );
}

export default AccountSettingsPage;
